import React, { Component } from 'react';
import {Container, Card, Form, Button, Row, Col} from 'react-bootstrap';
import validator from 'validator';

class ReferralForm extends Component {

    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.state = {
            employeeReason: '',
            employeeName: '',
            employeeEmail: '',
            employeeOffice: '',
            employeeTitle: '',
            studentName: '',
            studentUIN: '',
            studentEmail: '',
            studentPhone: '',
            studentAmount: ''
        }
        this.props.instance.getAllAccounts()[0];
    }

    submit = async () => {
        if (!validator.isEmail(this.state.employeeEmail)) {
            alert("Please enter valid Email address for Employee");
            return;
        }
        if (!validator.isNumeric(this.state.studentUIN)) {
            alert("Please enter valid UIN");
            return;
        }
        if (!validator.isEmail(this.state.studentEmail)) {
            alert("Please enter valid Email address for Student");
            return;
        }
        if (!validator.isMobilePhone(this.state.studentPhone)) {
            alert("Please enter valid phone number for Student");
            return;
        }
        if (!validator.isNumeric(this.state.studentAmount)) {
            alert("Please enter valid amount");
            return;
        }
        let params = { scopes: ["user.read"], account: this.props.instance.getAllAccounts()[0] };
        let inputData = {
            EmployerEmail: this.state.employeeEmail,
            Reason: this.state.employeeReason,
            EmployerName: this.state.employeeName,
            EmployerOffice: this.state.employeeOffice,
            EmployerTitle: this.state.employeeTitle,
            StudentEmail: this.state.studentEmail,
            StudentName: this.state.studentName,
            StudentUin: this.state.studentUIN,
            StudentPhoneNo: this.state.studentPhone,
            Amount: this.state.studentAmount
        };
        this.props.instance.acquireTokenSilent(params).then(response => {
            let id_token = response.idToken;
            let access_token = response.accessToken;
            console.log(JSON.stringify(inputData));
            console.log(id_token);
            fetch('./api/form', {
                method: 'POST',
                headers: new Headers({
                    'Authorization': 'Bearer ' + id_token,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(inputData)
            }).then(function (response) {
                if (response.status != 200)
                    alert("Submission not successful");
                else
                    alert("Submission Successful");
                window.location.reload();
            });
        });
    }

    render() {
        return (
            <Container>
                <h1 style={{marginTop:'20px'}}>
                    ATTENTION: We have reached the end of funding for this grant. We will no longer be accepting referrals.
                </h1>
                {/*<Card>*/}
                {/*    <Card.Header>Referral Form</Card.Header>*/}
                {/*    <Container>*/}
                {/*        <Card>*/}
                {/*            <Card.Body>*/}
                {/*    <p>Please complete the below application to refer a currently enrolled UIC student to receive an Emergency Grant typically up to $2500 though the GEER Emergency Grant Program.</p>*/}
                {/*    <p>To be eligible for the grant, students must meet the below criteria:</p>*/}
                {/*    <ul>*/}
                {/*        <li>A UIC degree-seeking, undergraduate student</li>*/}
                {/*        <li>Currently enrolled</li>*/}
                {/*        <li>A US Citizen/Resident; DACA recipient; Undocumented resident</li>*/}
                {/*    </ul>*/}
                {/*    <p>Students <u>are</u> eligible even if they:</p>*/}
                {/*    <ul>*/}
                {/*        <li>have already received a U and I Care grant</li>*/}
                {/*        <li>have already received a HEERF/COVID-19 Emergency Grant</li>*/}
                {/*                </ul>*/}
                {/*            </Card.Body>*/}
                {/*        </Card>*/}
                {/*    </Container>*/}
                {/*    <Card.Body>*/}
                {/*        <h2>Your Information</h2>*/}
                {/*        <Form>*/}
                {/*            <Form.Group controlId="empName">*/}
                {/*                <Form.Label>Name</Form.Label>*/}
                {/*                <Form.Control placeholder="John Smith" value={this.state.employeeName}*/}
                {/*                    onChange={e => this.setState({ employeeName: e.target.value })} />*/}
                {/*            </Form.Group>*/}
                {/*            <Form.Group controlId="empEmail">*/}
                {/*                <Form.Label>Email</Form.Label>*/}
                {/*                <Form.Control placeholder="abc@uic.edu" value={this.state.employeeEmail}*/}
                {/*                    onChange={e => this.setState({ employeeEmail: e.target.value })} />*/}
                {/*            </Form.Group>*/}
                {/*            <Form.Group controlId="office">*/}
                {/*                <Form.Label>Office</Form.Label>*/}
                {/*                <Form.Control placeholder="" value={this.state.employeeOffice}*/}
                {/*                    onChange={e => this.setState({ employeeOffice: e.target.value })} />*/}
                {/*            </Form.Group>*/}
                {/*            <Form.Group controlId="title">*/}
                {/*                <Form.Label>Title</Form.Label>*/}
                {/*                <Form.Control placeholder="" value={this.state.employeeTitle}*/}
                {/*                    onChange={e => this.setState({ employeeTitle: e.target.value })} />*/}
                {/*            </Form.Group>*/}
                {/*        </Form>*/}
                {/*        <h2>Student Information</h2>*/}
                {/*        <Form>*/}
                {/*            <Form.Group controlId="studentName">*/}
                {/*                <Form.Label>Name</Form.Label>*/}
                {/*                <Form.Control placeholder="John Smith" value={this.state.studentName}*/}
                {/*                    onChange={e => this.setState({ studentName: e.target.value })} />*/}
                {/*            </Form.Group>*/}
                {/*            <Form.Group controlId="studentUIN">*/}
                {/*                <Form.Label>UIN</Form.Label>*/}
                {/*                <Form.Control placeholder="123456789" value={this.state.studentUIN}*/}
                {/*                    onChange={e => this.setState({ studentUIN: e.target.value })} />*/}
                {/*            </Form.Group>*/}
                {/*            <Form.Group controlId="studentEmail">*/}
                {/*                <Form.Label>Email</Form.Label>*/}
                {/*                <Form.Control placeholder="abc@uic.edu" value={this.state.studentEmail}*/}
                {/*                    onChange={e => this.setState({ studentEmail: e.target.value })} />*/}
                {/*            </Form.Group>*/}
                {/*            <Form.Group controlId="studentPhone">*/}
                {/*                <Form.Label>Phone</Form.Label>*/}
                {/*                <Form.Control placeholder="1234567890" value={this.state.studentPhone}*/}
                {/*                    onChange={e => this.setState({ studentPhone: e.target.value })} />*/}
                {/*            </Form.Group>*/}
                {/*            <Form.Group controlId="amountRequested">*/}
                {/*                <Form.Label>Amount Requested</Form.Label>*/}
                {/*                <Form.Control placeholder="1500" value={this.state.studentAmount}*/}
                {/*                    onChange={e => this.setState({ studentAmount: e.target.value })} />*/}
                {/*            </Form.Group>*/}
                {/*            <Form.Group controlId="empReason">*/}
                {/*                <Form.Label>Referral Reason</Form.Label>*/}
                {/*                <Form.Control as="textarea" rows={4} placeholder="State Reason Here" value={this.state.employeeReason}*/}
                {/*                    onChange={e => this.setState({ employeeReason: e.target.value })} />*/}
                {/*                <Form.Text className='text-muted'>*/}
                {/*                    Please provide enough details so that an assessment of the situation can be made.*/}
                {/*                </Form.Text>*/}
                {/*            </Form.Group>*/}
                {/*        </Form>*/}
                {/*        <p>Please contact Jo Berry at jberry25@uic.edu or Sue Farruggia at spf@uic.edu with any questions.</p>*/}
                {/*    </Card.Body>*/}
                {/*    <Card.Footer>*/}
                {/*        <Button onClick={this.submit} > Submit Referral Form</Button>*/}
                {/*    </Card.Footer>*/}
                {/*</Card>*/}
            </Container>
        );
    }
}

export default ReferralForm;